
import { createRouter,createWebHashHistory } from "vue-router";

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue'),
        meta: { title: '首页', symbol: 'S' }
    },
    // {
    //     path: '/recruit',
    //     name: 'recruit',
    //     component: () => import('../views/Recruit.vue'),
    //     meta: { title: '人才招聘'}
    // },

]

const router = createRouter({
    history:createWebHashHistory(),
    routes
})
router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0); // 将滚动位置设置为顶部
    next();
});

export default router
